import React from 'react';

const ChannelInit = React.lazy(() => import('../../modules/channelUser/ChannelInit'));
const Join = React.lazy(() => import('../../modules/auth/AuthPage/Entry/Join'));
const Login = React.lazy(() => import('../../modules/auth/AuthPage/Entry/Login'));
const JoinEmail = React.lazy(() => import('../../modules/auth/AuthPage/JoinEmail'));
const LoginEmail = React.lazy(() => import('../../modules/auth/AuthPage/LoginEmail'));
const FindPassword = React.lazy(() => import('../../modules/auth/AuthPage/FindPassword'));
const AccountResetForm = React.lazy(() => import('../../modules/auth/AuthPage/ResetPassword/AccountResetForm'));
const SocialLoginCallback = React.lazy(() => import('../../modules/auth/AuthPage/SocialLoginCallback'));
const VerifyPhoneNumber = React.lazy(() => import('../../modules/auth/AuthPage/VerifyPhoneNumber'));
const GoogleSignupForm = React.lazy(() => import('../../modules/auth/AuthPage/GoogleSignupForm'));


const ForgetPassword = React.lazy(() => import('@crema/modules/auth/ForgetPassword'));
const ConfirmSignupAwsCognito = React.lazy(() => import('../../modules/auth/Signup/ConfirmSignupAwsCognito'));
const PasswordExpired = React.lazy(() => import('@crema/modules/auth/PasswordExpired'));
const ChangePassword = React.lazy(() => import('@crema/modules/auth/ChangePassword'));
const AccountVerification = React.lazy(() => import('../../modules/auth/AccountVerification'));
const Cafe24Auth = React.lazy(() => import('../../modules/auth/Cafe24Auth'));
// import Platform from '../../modules/auth/AuthPage/Platform';

export const authRouteConfig = [
  {
    path: '/signin',
    element: <Login />,
  },
  {
    path: '/signin/email',
    element: <LoginEmail />,
  },
  {
    path: '/signup',
    element: <Join />,
  },
  {
    path: '/signup/email',
    element: <JoinEmail />,
  },
  {
    path: '/signup/verify-phone',
    element: <VerifyPhoneNumber />,
  },
  {
    path: '/signup/google-info',
    element: <GoogleSignupForm />,
  },
  {
    path: '/forget-password',
    element: <FindPassword />,
  },
  {
    path: '/confirm-signup',
    element: <ConfirmSignupAwsCognito />,
  },
  {
    path: '/change-password',
    element: <ChangePassword />,
  },

  {
    path: '/reset-password',
    element: <AccountResetForm />,
  },

  {
    path: '/password-expired',
    element: <PasswordExpired />,
  },

  {
    path: '/email-verification',
    element: <AccountVerification />,
  },
  {
    path: '/callback/:socialName',
    element: <SocialLoginCallback />,
  },
  {
    path: '/:channel_id',
    element: <ChannelInit />,
  },
];
